import React, {useState, useEffect} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser, faBars, faSignOutAlt, faCog, faAngleDown, faTrash} from "@fortawesome/free-solid-svg-icons";

import "./Header.css";
import aurumLogo from "../../../resources/images/aurum-logo.png";
import {retrieveLoggedInSystemUser} from "../../../services/StaffMemberService";

export const Header = ({context, setContext, navigateTo, setShowMenu, keycloak}) => {

    const [showDropdown, setShowDropdown] = useState(false);
    const [date, setDate] = useState(new Date());

    useEffect(() => {
        let timer = setInterval(() => {
            setDate(new Date());
        }, 1000);
        return () => {
            clearInterval(timer);
        }
    }, []);

    const toggleDropDown = () => {
        setShowDropdown((prevState) => !prevState);
    }

    const handleSettingsClick = () => {
        setShowDropdown(false);
        setContext((prevState) => ({
            ...prevState,
            activeSection: "Account",
        }));
        navigateTo("dashboardAccount");
    }

    const handleClearSessionClick = async () => {
        setShowDropdown(false);
        const username = context.username;
        const roles = context.roles;
        const [data, error] = await retrieveLoggedInSystemUser(username);
        if (data) {
            if (data.responseStatus === "Success") {
                setContext({
                    currentScreen: "dashboardProfile",
                    viewStack: [],
                    breadcrumbs: [],
                    activeSection: "Profile",
                    username,
                    roles,
                    loggedInUser: data.systemUserVO,
                });
            } else {
                console.error(data.responseMessage);
            }
        } else {
            console.error(error);
        }
    }

    const handleLogOutClick = () => {
        keycloak.logout();
    }

    const buildDateString = () => {
        const time = date.toLocaleTimeString('en-US', {hour12: false});
        const day = date.getDate();
        const month = date.toLocaleString('default', {month: 'long'});
        const year = date.getFullYear();
        return `${time}, ${day} ${month} ${year}`;
    }

    return (
        <div className='header-container'>
            <div className="header-logo-container">
                <img src={aurumLogo} alt="Aurum Logo"/>
            </div>
            <div className="header-title-container">
                <div className="header-dark-green-block">
                    <div className="header-menu-button-container" onClick={() => {
                        setShowMenu((prevState) => (!prevState));
                    }}>
                        <FontAwesomeIcon className="header-menu-button" icon={faBars}/>
                    </div>
                    <p>Quality Improvement Tracker</p>
                </div>
                <div className="header-red-block"/>
                <div className="header-powder-blue-block"/>
                <div className="header-light-green-block"/>
                <div className="header-purple-block"/>
                <div className="header-orange-block"/>
                <div className="header-light-blue-block"/>
            </div>
            <div className="header-dropdown-menu-container">
                <div className="header-username-time-container">
                    <p className="bold">{context.username}</p>
                    <p>{buildDateString()}</p>
                </div>
                <div className="header-icon-container">
                    <FontAwesomeIcon data-testid="header-button" className="header-user-icon" icon={faUser} onClick={toggleDropDown}/>
                    <FontAwesomeIcon className="header-dropdown-icon" icon={faAngleDown} onClick={toggleDropDown}/>
                </div>
                {showDropdown && <div className="header-dropdown-menu">
                    <div className="header-dropdown-menu-item" onClick={handleSettingsClick}>
                        <div className="header-dropdown-menu-item-icon">
                            <FontAwesomeIcon className="header-dropdown-menu-item-icon" icon={faCog}/>
                        </div>
                        <p>Settings</p>
                    </div>
                    <div className="header-dropdown-menu-item" onClick={handleClearSessionClick}>
                        <div className="header-dropdown-menu-item-icon">
                            <FontAwesomeIcon className="header-dropdown-menu-item-icon" icon={faTrash}/>
                        </div>
                        <p>Clear Session</p>
                    </div>
                    <div className="header-dropdown-menu-item" onClick={handleLogOutClick}>
                        <div className="header-dropdown-menu-item-icon">
                            <FontAwesomeIcon className="header-dropdown-menu-item-icon" icon={faSignOutAlt}/>
                        </div>
                        <p>Sign Out</p>
                    </div>
                </div>}
            </div>
        </div>
    );
}
